import axios from 'axios';
import { Store } from 'vuex';
import VueRouter from 'vue-router';
import TranslationService from '@/locale/translation.service';
import { Authority } from '@/shared/security/authority';
// import { Account } from '@/shared/model/account.model';

const baseBriefingAPI = '/api/briefing';

export default class AccountService {
  constructor(private store: Store<any>, private translationService: TranslationService, private router: VueRouter) {
    this.init();
  }
  public init(): void {
    this.retrieveProfiles();
    // this.userLogIn();
  }

  public retrieveProfiles(): Promise<boolean> {
    return new Promise(resolve => {
      axios
        .get('management/info')
        .then(res => {
          if (res.data && res.data.activeProfiles) {
            this.store.commit('setRibbonOnProfiles', res.data['display-ribbon-on-profiles']);
            this.store.commit('setActiveProfiles', res.data['activeProfiles']);
          }
          resolve(true);
        })
        .catch(() => resolve(false));
    });
  }

  public getTokenByGuestId(guestId: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get('api/get-token-by-guest-id?guestId=' + guestId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  waitingAccountApi = false;
  public retrieveAccount(): Promise<boolean> {
    if (this.waitingAccountApi) {
      return;
    }

    this.waitingAccountApi = true;
    return new Promise(resolve => {
      axios
        .get('api/account')
        .then(response => {
          this.store.commit('authenticate');
          const account = response.data;
          if (account) {
            if (account.authorities.includes(Authority.GUEST)) {
              localStorage.setItem('_gid', account.id);
            }
            this.store.commit('authenticated', account);
            localStorage.setItem('localStorageUser', JSON.stringify(account));
            if (sessionStorage.getItem('requested-url')) {
              if (sessionStorage.getItem('requested-url') !== this.router.currentRoute.fullPath) {
                this.router.replace(sessionStorage.getItem('requested-url'));
              }
              sessionStorage.removeItem('requested-url');
            }
          } else {
            this.store.commit('logout');
            this.router.push('/', () => {});
            sessionStorage.removeItem('requested-url');
          }
          this.translationService.refreshTranslation(this.store.getters.currentLanguage);
          resolve(true);
        })
        .catch(() => {
          this.store.commit('logout');
          resolve(false);
        })
        .finally(() => {
          this.waitingAccountApi = false;
        });
    });
  }

  public hasAnyAuthorityAndCheckAuth(authorities: any): Promise<boolean> {
    if (typeof authorities === 'string') {
      authorities = [authorities];
    }

    if (!this.authenticated || !this.userAuthorities) {
      const token = localStorage.getItem('ds-authenticationToken') || sessionStorage.getItem('ds-authenticationToken');
      if (!this.store.getters.account && !this.store.getters.logon && token) {
        return this.retrieveAccount();
      } else {
        return Promise.resolve(false);
      }
    }

    for (const authority of authorities) {
      if (this.userAuthorities.includes(authority)) {
        return Promise.resolve(true);
      }
    }

    return Promise.resolve(false);
  }

  public get authenticated(): boolean {
    return this.store.getters.authenticated;
  }

  public get userAuthorities(): any {
    return this.store.getters.account.authorities;
  }

  // public getUserLogin(): Account {
  //   const account = new Account(this.store.getters.account.id, this.store.getters.account.login);
  //   return account;
  // }

  public userLogIn() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/home/userLogIn')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIUpdateLocalUser(): Promise<boolean> {
    return new Promise(resolve => {
      axios
        .get('api/account')
        .then(response => {
          this.store.commit('authenticate');
          const account = response.data;

          if (account) {
            this.store.commit('authenticated', account);
            localStorage.setItem('localStorageUser', JSON.stringify(account));
          }

          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  refreshToken(isForce = false) {
    const isCheckResetTk = true;

    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/refreshToken', null, {
          params: {
            isCheckResetTk,
            isForce,
          },
        })
        .then(res => {
          if (localStorage.getItem('ds-authenticationToken')) {
            localStorage.setItem('ds-authenticationToken', res.data.id_token);
          } else {
            sessionStorage.setItem('ds-authenticationToken', res.data.id_token);
          }
          resolve(res);
        })
        .catch(err => reject(err));
    });
  }
}
